// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { arrowExpanderDown16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { IconSvg, registerIconSvg } from '../../icon-svg';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-arrow-expander-down': IconArrowExpanderDown;
    }
}

/**
 * The icon component for the 'arrowExpanderDown' icon
 */
export class IconArrowExpanderDown extends IconSvg {
    public constructor() {
        super(arrowExpanderDown16X16);
    }
}

registerIconSvg('icon-arrow-expander-down', IconArrowExpanderDown);
export const iconArrowExpanderDownTag = 'nimble-icon-arrow-expander-down';
